export default __webpack_public_path__ + "static/media/Robot.18d18f54.svg";